import {Injectable} from "@angular/core";
import {FormFieldConfig} from "../../../model/api/form-field-config";
import {FormFieldGroupConfig} from "../../../model/api/form-field-group-config";
import {Trade} from "../../../model/clearing/trade";
import {resolveFieldTypes} from "../../../utils/object-reflection";
import {
  BatchActionSupportTradeFormComponent
} from "../../../crystal-clear/support/trade-crud/batch-update-form/batch-action-support-trade-form.component";
import {SupportTradeDataLoadingService} from "./support-trade-data-loading.service";
import {FieldRecord} from "../../../model/api/field-record";
import {Account} from "../../../model/clearing/account";
import {TableColumnConfig} from "../../../model/api/table-column-config";
import {TableColumnUtils} from "../../../utils/table-column-utils";
import TYPE = FormFieldConfig.TYPE;
import {BatchFormUtils} from "../../../utils/batch-form-utils";
import {SupportTradeFormConfigService} from "./support-trade-form-config.service";

@Injectable({
  providedIn: 'root'
})
export class SupportTradeBatchFormConfigService {

  /** fields selected for update */
  fieldsToUpdate: string[] = [];

  private readonly excludedFields = [
    'id',
    'account',
    'clearings',
    'clearingInfo'
  ];

  loadConfig(
    component: BatchActionSupportTradeFormComponent
  ): FormFieldGroupConfig[] {

    const tradeFields: FormFieldConfig[] =
      (Object.keys(new Trade()) as Array<keyof Trade>)
        .filter(f => BatchFormUtils.isEditable(f as string, this.excludedFields))
        .map(f =>
          BatchFormUtils.buildBatchField<Trade>(
            f,
            SupportTradeFormConfigService.fieldTypes[f],
            this.fieldsToUpdate,
            component.ccFormDialog
          )
        );

    tradeFields.forEach(
      f => f.options = SupportTradeFormConfigService.buildOptions(f, component.dataLoadingService)
    );

    const accountFields: FormFieldConfig[] =
      (Object.keys(new Account()) as Array<keyof Account>)
        .filter(f => BatchFormUtils.isEditable(f as string, this.excludedFields))
        .map(f =>
          BatchFormUtils.buildBatchField<Account>(
            f,
            SupportTradeFormConfigService.fieldTypes[f],
            this.fieldsToUpdate,
            component.ccFormDialog,
            'account.'
          )
        );

    const accountColumns: TableColumnConfig[] =
      (Object.keys(new Account()) as Array<keyof Account>)
        .map(f =>
          TableColumnUtils.buildColumn<Account>(
            f,
            SupportTradeFormConfigService.fieldTypes[f]
          )
        );

    return [
      {
        group: 'account',
        fields: [
          {
            field: 'account',
            column: 12,
            type: TYPE.SINGLERICHFIELD,
            richFieldConfig: {
              fieldId: 'name',
              fieldName: 'name',
              tableConfigs: accountColumns,
              fields: [{ group: '', fields: accountFields }]
            }
          }
        ]
      },
      {
        group: 'fields',
        fields: tradeFields
      }
    ];
  }

}
